/**
 * 折上折金币
 */
const goldCoinRouter = [
  {
    path: `/gold-coin`,
    component: () => import(`@/views/gold-coin/index`),
    name: `GoldCoin`,
    meta: { title: '折上折金币', auth: false },
  },
  {
    path: `/gold-coin/binding`,
    component: () => import(`@/views/gold-coin/binding`),
    name: `Binding`,
    meta: { title: '绑定微信说明', auth: false },
  },
  {
    path: `/gold-coin/gold-details`,
    component: () => import(`@/views/gold-coin/gold-details`),
    name: `GoldDetails`,
    meta: { title: '金币明细', auth: false },
  },
  {
    path: `/gold-coin/gold-explain`,
    component: () => import(`@/views/gold-coin/gold-explain`),
    name: `GoldExplain`,
    meta: { title: '折上折金币说明', auth: false },
  },
  {
    path: `/gold-coin/withdrawal-explain`,
    component: () => import(`@/views/gold-coin/withdrawal-explain`),
    name: `WithdrawalExplain`,
    meta: { title: '提现说明', auth: false },
  },
  {
    path: `/gold-coin/withdraw-process`,
    component: () => import(`@/views/gold-coin/withdraw-process`),
    name: `WithdrawProcess`,
    meta: { title: '金币提现', auth: false },
  },
  {
    path: `/gold-coin/withdraw-record`,
    component: () => import(`@/views/gold-coin/withdraw-record`),
    name: `WithdrawRecord`,
    meta: { title: '提现记录', auth: false },
  },
  {
    path: `/gold-coin/bind-account`,
    component: () => import(`@/views/gold-coin/bind-account`),
    name: `BindAccount`,
    meta: { title: '绑定账户', auth: false },
  },
  {
    path: `/gold-coin/withdraw`,
    component: () => import(`@/views/gold-coin/withdraw`),
    name: `Withdraw`,
    meta: { title: '金币提现', auth: false },
  },
  {
    path: `/gold-coin/bind-name`,
    component: () => import(`@/views/gold-coin/bind-name`),
    name: `BindName`,
    meta: { title: '认证真实姓名', auth: false },
  },
  {
    path: `/gold-coin/bind-login`,
    component: () => import(`@/views/gold-coin/bind-login`),
    name: `BindLogin`,
    meta: { title: '登录', auth: false },
  },
  {
    path: `/mammon-detail`,
    component: () => import(`@/views/themepage/mammonDetail`),
    name: `mammonDetail`,
    meta: { title: '跨年红包', auth: false },
  },
  {
    path: `/mammon-rule`,
    component: () => import(`@/views/themepage/mammonRule`),
    name: `mammonRule`,
    meta: { title: '规则说明', auth: false },
  },
];

export default goldCoinRouter;
